module.exports = __webpack_public_path__ + "static/media/xcode.83224cff.png";